var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cycle-table-container"}},[_c('div',{staticClass:"ct-header"},[_vm._v(" Cycle History ")]),_c('div',{staticClass:"ct-container"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.leadCycleData,"hide-default-footer":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }